import React, { createContext, useState, useContext, useEffect } from "react";

const PrzekazyPaginationContext = createContext();

export const usePaginationPrzekazy = () => {
	return useContext(PrzekazyPaginationContext);
};

export const PaginationProviderPrzekazy = ({ children }) => {
	const [pagination, setPagination] = useState({
		current:
			JSON.parse(localStorage.getItem("currentPageMSRPrzekazy")) || 1,
		pagesize: JSON.parse(localStorage.getItem("MSRPagesizePrzekazy")) || 20,
		loading: false,
		generated: false,
		search: JSON.parse(localStorage.getItem("searchPrzekazy")) || null,
		advancedSearch:
			JSON.parse(localStorage.getItem("advancedSearchMSRPrzekazy")) ||
			null,
		orderby: [],
		reload: false,
	});

	useEffect(() => {
		localStorage.setItem(
			"currentPageMSRPrzekazy",
			JSON.stringify(pagination.current)
		);
		localStorage.setItem(
			"advancedSearchMSRPrzekazy",
			JSON.stringify(pagination.advancedSearch)
		);
		localStorage.setItem(
			"MSRPagesizePrzekazy",
			JSON.stringify(pagination.pagesize)
		);
		localStorage.setItem(
			"searchPrzekazy",
			JSON.stringify(pagination.search)
		);
	}, [pagination]);

	return (
		<PrzekazyPaginationContext.Provider
			value={{ pagination, setPagination }}
		>
			{children}
		</PrzekazyPaginationContext.Provider>
	);
};
